"use strict";
/*
 * Created on 22. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var FinalProductPriceConverter_1 = require("../../release/conversions/FinalProductPriceConverter");

var PriceCommentConverter_1 = require("../../release/conversions/PriceCommentConverter");

var PriceChangeReportPricesDTO_1 = require("../model/PriceChangeReportPricesDTO");

var PriceChangeReportPricesDTOConverter_1 = require("./PriceChangeReportPricesDTOConverter");
/**
 * Default implementation of price change report prices converter.
 *
 * @author SKu
 */


var PriceChangeReportPricesDTOConverterImpl =
/*#__PURE__*/
function (_PriceChangeReportPri) {
  _inherits(PriceChangeReportPricesDTOConverterImpl, _PriceChangeReportPri);

  function PriceChangeReportPricesDTOConverterImpl(finalProductPriceConverter, priceCommentConverter) {
    var _this;

    _classCallCheck(this, PriceChangeReportPricesDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportPricesDTOConverterImpl).call(this));
    _this.finalProductPriceConverter = finalProductPriceConverter;
    _this.priceCommentConverter = priceCommentConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceChangeReportPricesDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new PriceChangeReportPricesDTO_1.PriceChangeReportPricesDTO(PriceChangeReportPricesDTO_1.PriceChangeReportPricesDTO.schema.pricingAreaId.valueOf(conversions.toClassReferenceId(source.pricingAreaId)), conversions.asObject(source, 'finalPrice', function (doc) {
        return _this2.finalProductPriceConverter.toObject(doc, conversions);
      }), PriceChangeReportPricesDTO_1.PriceChangeReportPricesDTO.schema.comments.valueOf(conversions.asObjectList(source, 'comments', function (doc) {
        return _this2.priceCommentConverter.toObject(doc, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {
        pricingAreaId: conversions.toDocumentReferenceId(source.pricingAreaId),
        finalPrice: this.finalProductPriceConverter.toDocument(source.finalPrice, conversions),
        comments: conversions.asObjectArray(source, 'comments', function (field) {
          return _this3.priceCommentConverter.toDocument(field, conversions);
        })
      };
      return result;
    }
  }]);

  return PriceChangeReportPricesDTOConverterImpl;
}(PriceChangeReportPricesDTOConverter_1.PriceChangeReportPricesDTOConverter);

PriceChangeReportPricesDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [FinalProductPriceConverter_1.FinalProductPriceConverter, PriceCommentConverter_1.PriceCommentConverter])], PriceChangeReportPricesDTOConverterImpl);
exports.PriceChangeReportPricesDTOConverterImpl = PriceChangeReportPricesDTOConverterImpl;